var E={0:"APPLIED/SENT",1:"SHORTLISTED",2:"NOT SUITABLE",3:"SAVED FOR FUTURE",4:"VIEWED",5:"DOWNLOADED",101:"YOUR STATUS HAS BEEN CHANGED",9:"ROUND ZERO VIEWED"};export{E as RECRUITER_ACTION_TEXT};
//# sourceMappingURL=types.js.map
